import React from 'react';
import { useDispatch } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { isNull, isUndefined } from 'lodash';

import { Loading, LoadingError } from '@components/Base';
import { RightCol } from '@components/HealthQuoteBuyRoute/right-col';
import HealthQuoteBuyForm, { FormValues } from '@components/HealthQuoteBuyRoute/HealthQuoteBuyForm';

import { personalAccidentQuoteUpdate, PersonalAccidentQuoteUpdatePayload } from '../action';
import { usePersonalAccidentQuoteFetch } from '../hook';
import { useInitialValues } from './hook';

const PersonalAccidentQuoteBuyEditPage = () => {
  const dispatch = useDispatch();
  const personalAccidentQuote = usePersonalAccidentQuoteFetch();
  const initialValues = useInitialValues();

  if (isUndefined(personalAccidentQuote)) return <Loading />;
  if (isNull(personalAccidentQuote)) return <LoadingError />;
  if (!initialValues) return null;

  const {
    orderNumber,
    personalAccidentPlanName,
    personalAccidentPlanQuestions,
    occupationDeclarationDescription } = personalAccidentQuote;

  const handleSubmit = (values: FormValues) => {
    const payload: PersonalAccidentQuoteUpdatePayload = { orderNumber, ...values };
    dispatch(personalAccidentQuoteUpdate(payload));
  };

  return (
    <Container className="my-3">
      <Row className="gy-5">
        <Col lg={8}>
          <HealthQuoteBuyForm
            initialValues={initialValues}
            onSubmit={handleSubmit}
            questions={personalAccidentPlanQuestions}
            description={occupationDeclarationDescription} />
        </Col>
        <RightCol {...personalAccidentQuote} planName={personalAccidentPlanName} />
      </Row>
    </Container>
  );
};

export { PersonalAccidentQuoteBuyEditPage };
